import { Reveal } from "./Reveal";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";

export const Testimonials = () => (
  <section
    id="opiniones"
    data-testid="testimonials-section"
    className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36"
  >
    <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
      <div className="lg:col-span-8">
        <Reveal>
          <div className="eyebrow text-accent mb-5">Lo que dicen nuestros clientes</div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-ink leading-[0.95] tracking-tight text-4xl sm:text-5xl lg:text-6xl">
            Miles de pies felices
            <br />
            <span className="italic text-brand-soft">hablan por nosotros</span>
          </h2>
        </Reveal>
      </div>
    </div>

    <div className="grid md:grid-cols-2 gap-6 md:gap-8">
      {TESTIMONIALS.map((t, i) => (
        <Reveal key={i} delay={(i % 2) * 0.1}>
          <figure
            data-testid={`testimonial-${i}`}
            className={`h-full rounded-2xl p-8 md:p-10 border border-line ${
              i % 3 === 0 ? "bg-brand text-white" : "bg-surface text-ink"
            }`}
          >
            <Quote
              size={34}
              className={i % 3 === 0 ? "text-accent" : "text-brand-soft"}
            />
            <blockquote className="font-serif font-light text-2xl md:text-3xl leading-snug mt-5 mb-8 tracking-tight">
              “{t.q}”
            </blockquote>
            <figcaption className="flex items-center gap-3">
              <span
                className={`grid place-items-center h-10 w-10 rounded-full text-sm font-medium ${
                  i % 3 === 0 ? "bg-white/15 text-white" : "bg-mutedbg text-brand"
                }`}
              >
                {t.a[0]}
              </span>
              <div>
                <div className="text-sm font-medium">{t.a}</div>
                <div className={`text-xs ${i % 3 === 0 ? "text-white/50" : "text-ink/50"}`}>
                  {t.r}
                </div>
              </div>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);
